import * as React from 'react';
import { Text as RNText } from 'react-native';
import { Text as TextSlot } from '@rn-primitives/slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const textVariants = cva('font-franie text-base text-foreground', {
  variants: {
    variant: {
      default: '',
      h1: 'text-4xl font-bold tracking-tight',
      h2: 'text-3xl font-bold tracking-tight',
      h3: 'text-2xl font-semibold',
      h4: 'text-xl font-semibold',
      p: 'text-base leading-6',
      lead: 'text-xl text-muted-foreground',
      large: 'text-lg font-semibold',
      small: 'text-sm font-medium leading-5',
      muted: 'text-sm text-muted-foreground leading-5',
      code: 'relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold',
      blockquote: 'border-l-2 border-border pl-6 italic',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type TextProps = React.ComponentPropsWithoutRef<typeof RNText> &
  VariantProps<typeof textVariants> & {
    asChild?: boolean;
  };

const Text = React.forwardRef<React.ElementRef<typeof RNText>, TextProps>(
  ({ className, variant, asChild = false, ...props }, ref) => {
    const Component = asChild ? TextSlot : RNText;

    return (
      <Component
        ref={ref}
        className={cn(textVariants({ variant, className }))}
        {...props}
      />
    );
  }
);

Text.displayName = 'Text';

export { Text, textVariants };
export type { TextProps };
